import React, { useEffect, useState } from "react";

import { generateLinkForEntity, invalidateGenerateLink } from "actions/links";
import _ from "lodash";
import cx from "classnames";
import {
  Button,
  FormControl,
  InputGroup,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";


import styles from "./generateLink.module.scss";
import { useDispatch, useSelector } from "react-redux";

import buildUrl from "build-url";

import FileService from 'services/file.service';
import dateformat from 'dateformat';
import defaultAsset from 'images/default_asset.jpg';
import { trackAdoptionMetricsForGenerateLinkEvent } from "actions/adoption";

export default function GenerateLink({ entity, type, show, setShow }) {
  const dispatch = useDispatch();

  const handleBack = (e) => {
    dispatch(invalidateGenerateLink());
    setShow(false);
  };

  const renderAssetSummary = (asset) => {
    if (asset.metadata.pages) {
      return (
        <div className={styles.metrics}>
          <span>{asset.metadata.pages} Pages</span>
        </div>
      );
    } else if (asset.metadata.video_duration) {
      return (
        <div className={styles.metrics}>
          <span>{formartVideoDuration(asset.metadata.video_duration)}</span>
        </div>
      );
    }

    return false;
  }

  const formartVideoDuration = (timeSpent) => {
    let timeSpentValue = `${padNumber(timeSpent, 1)} Seconds`;

    if (timeSpent >= 60) {
      var minutes = Math.round(timeSpent / 60);
      timeSpentValue = `${padNumber(minutes, 1)} Minute${minutes == 1 ? '' : 's'}`;
    }

    return timeSpentValue;
  }

  const padNumber = (number = 0, pad) => {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = '';
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join('0');
    }
    return padding + number;
  }

  const renderAsset = (asset) => {
    return (
      <div key={asset.id} className={styles.asset}>
        <span className={styles.assetIcon}>
          <img
            alt="asset thumbnail"
            src={_.get(asset, "icon.thumbnail") || defaultAsset} />
        </span>
        <div className={styles.frequentlySharedText}>
          <p className={styles.frequentlySharedHeading}>{asset.name}</p>
        </div>
      </div>
    )
  }

  const renderCollection = (collection) => {
    return (
      <div>
        <div key={collection.id} className={styles.collection}>
          <span className={styles.collectionIcon}>
            <img
              alt="collection thumbnail"
              src={_.get(collection, "icon.thumbnail") || defaultAsset} />
          </span>
          <div className={styles.frequentlySharedText}>
            <p className={styles.frequentlySharedHeading}>{collection.name}</p>
            <p className={styles.frequentlySharedSubHeading}>

              {collection.assetsCount > 0 && (collection.assetsCount > 1 ?
                <span>{collection.assetsCount} assets</span> :
                <span> 1 asset </span>
              )}
              {collection.sectionsCount > 0 && (
                collection.sectionsCount > 1 ? <span> {collection.sectionsCount} sections </span> :
                  <span> 1 section </span>)}
            </p>
          </div>
        </div>
      </div>
    )
  }

  if (type === "asset") {
    var assetSummary = renderAssetSummary(entity);
  }

  const trackGenerateLink = (type) => {
    const capitalizedType = _.capitalize(type);
  
    if (_.get(entity, "entityType") === "asset") {
      dispatch(trackAdoptionMetricsForGenerateLinkEvent("Get Link Clicked", "Asset Detail", capitalizedType));
    } else {
      dispatch(trackAdoptionMetricsForGenerateLinkEvent("Get Link Clicked", "Collection Detail", capitalizedType, _.get(entity, "name", "")));
    }
  };

  return (
    <Modal
      show={show}
      dialogClassName={styles.generateLink}
      backdropClassName={styles.generateLinkOverlay}
    >
      <Modal.Body className={styles.modalBody}>
        <p className={styles.headerContainer}>
        <span className={styles.backButton} onClick={() => handleBack()}>
        <i className="paperflite-left-arrow"/>
        <span className={styles.back}>
          generate link
        </span>
        </span>
        </p>

        <div className={styles.content}>

          {type === "asset" && renderAsset(entity)}
          {type === "collection" && renderCollection(entity)}

          {entity && (
            <>
              <PersonalisedLink entity={entity} onClick={trackGenerateLink} />
              <AnonymousLink entity={entity} onClick={trackGenerateLink} />
              <CampaignLink entity={entity} onClick={trackGenerateLink} />
            </>
          )}

        </div>
      </Modal.Body>
    </Modal>
  );
}

function PersonalisedLink({ entity, onClick }) {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [valid, setValid] = useState(false);

  const generating = useSelector((state) =>
    _.get(state, `links.${entity.id}.personalised.generating`)
  );
  const url = useSelector((state) =>
    _.get(state, `links.${entity.id}.personalised.url`)
  );
  const utmCampaign = useSelector((state) =>
    _.get(state, `links.${entity.id}.personalised.utmCampaign`)
  );

  const onEmailChange = (e) => {
    setEmail(e.target.value);
    setValid(isValidEmail(e.target.value));
  };

  const isValidEmail = (value) => {
    var email = value;
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return (regex.test(email));
  }

  const handleSubmit = () => {
    const request = {
      type: "personalised",
      email: email,
    };

    dispatch(invalidateGenerateLink(entity))
    dispatch(generateLinkForEntity(entity, request));
    setEmail("")
    onClick(request.type); 
  };

  return (
    <div className={cx(styles.personalized)}>
      <p className={styles.header}> Personalized link</p>
      <p className={styles.subtext}>
        Who's the lucky prospect? Create a special link for them.
      </p>
      {!url && (
        <InputGroup className={styles.emailInput}>
          <FormControl
            placeholder={generating ? "Generating..." : "Enter recipient email here"}
            value={email}
            onChange={onEmailChange}
          />
          <InputGroup.Append>
            <Button
              variant="link"
              onClick={handleSubmit}
              disabled={!valid || generating}
              className={cx(styles.getLink, {
                [styles.validEmail]: valid
              })}
            >
              {generating && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}

              {valid && (
                <i className="paperflite-right-arrow" />
              )}

            </Button>
          </InputGroup.Append>
        </InputGroup>
      )}

      {url && <CopyLink url={url} className={styles.getLink} utmCampaign={utmCampaign} />}
    </div>
  );
}

function CampaignLink({ entity, onClick }) {
  const dispatch = useDispatch();
  const [campaign, setCampaign] = useState("");
  const [valid, setValid] = useState(false);

  const generating = useSelector((state) =>
    _.get(state, `links.${entity.id}.campaign.generating`)
  );
  const url = useSelector((state) =>
    _.get(state, `links.${entity.id}.campaign.url`)
  );
  const utmCampaign = useSelector((state) =>
    _.get(state, `links.${entity.id}.campaign.utmCampaign`)
  );

  const onCampaignNameChange = (e) => {
    setCampaign(e.target.value);

    if (_.size(e.target.value) > 0) {
      setValid(true);
    } else {
      setValid(false);
    }
  };

  const handleSubmit = () => {
    const request = {
      type: "campaign",
      utmCampaign: {
        name: campaign
      }
    };


    dispatch(invalidateGenerateLink(entity))
    dispatch(generateLinkForEntity(entity, request));
    setCampaign("")
    onClick(request.type); 
  };

  return (
    <div className={cx(styles.campaign)}>
      <p className={styles.header}> Executing a new campaign?</p>
      <p className={styles.subtext}>
        Don't be shy. Enter the name of your campaign and any additional information to generate a UTM link.
      </p>
      {!url && (
        <InputGroup className={styles.emailInput}>
          <FormControl
            placeholder={generating ? "Generating..." : "Enter campaign tag here"}
            value={campaign}
            onChange={onCampaignNameChange}
          />
          <InputGroup.Append>
            <Button
              variant="link"
              onClick={handleSubmit}
              disabled={!valid || generating}
              className={cx(styles.getLink, {
                [styles.validEmail]: valid
              })}
            >
              {generating && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}

              {!generating && "Get link"}
            </Button>
          </InputGroup.Append>
        </InputGroup>
      )}

      {url && <CopyLink url={url} className={styles.getLink} utmCampaign={utmCampaign} />}
    </div>
  );
}

function AnonymousLink({ entity, onClick }) {
  const dispatch = useDispatch();

  const generating = useSelector((state) =>
    _.get(state, `links.${entity.id}.anonymous.generating`)
  );
  const url = useSelector((state) =>
    _.get(state, `links.${entity.id}.anonymous.url`)
  );
  const utmCampaign = useSelector((state) =>
    _.get(state, `links.${entity.id}.anonymous.utmCampaign`)
  );

  const handleAnonymousLink = () => {
    const request = {
      type: "anonymous",
    };

    dispatch(invalidateGenerateLink(entity))
    dispatch(generateLinkForEntity(entity, request));
    onClick(request.type); 
  };

  return (
    <div className={cx(styles.anonymous)}>
      <div className={styles.inner}>
        <div className={styles.row}>
          <p className={styles.header}>Anonymous Link</p>
          <p className={styles.subtext}>
            Use this link for a quick share. User level tracking is not available for this link.
          </p>
        </div>

        {!url && (
          <Button
            variant="link"
            onClick={handleAnonymousLink}
            disabled={generating}
            className={styles.getLink}
          >
            {generating && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )}

            {!generating && (
              <div className={styles.getLinkContent}>
                <i className="paperflite-right-arrow" /> Get link
              </div>
            )}
          </Button>
        )}
      </div>

      {url && <CopyLink url={url} utmCampaign={utmCampaign} />}
    </div>
  );
}

function CopyLink({ url, utmCampaign }) {
  const inputRef = React.createRef(null);
  const [copied, setCopied] = useState(false);

  const handleClick = (e) => {
    e.target.select();
  };

  const handleCopy = () => {
    inputRef.current.value = prepareUtmLink();
    inputRef.current.select();
    document.execCommand("copy");
    setCopied(true);
  };

  const prepareUtmLink = () => {
    var utmLink = url;
    var queryParams = {};

    if (utmCampaign !== null) {
      var utmCampaignLink = _.omitBy(utmCampaign, _.isNil);
      _.forOwn(utmCampaignLink, (value, key) => {
        queryParams[`utm_${key}`] = value;
      });
      utmLink = buildUrl(utmLink, {
        queryParams: queryParams,
      });
    }
    return utmLink;
  };

  return (
    <InputGroup className={styles.copyLink}>
      <FormControl ref={inputRef} onClick={handleClick} value={url} readOnly />
      <InputGroup.Append>
        <Button className={cx(styles.copyButton, {
          [styles.copied] : copied
        })} variant="link" onClick={handleCopy}>
          {copied ? 'COPIED!' : 'COPY LINK'}
        </Button>
      </InputGroup.Append>
    </InputGroup>
  );
}
